import React, {useContext} from "react";
import {useI18N} from "../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../pages/ProductStencil";

export const OverlayLabel = () => {
    const translate = useI18N();
    const {setShowBasketOverlay} = useContext(ProductContext);


    return (
        <div className="overlay-content__label">
            <div className={"overlay-content__label__icon svg-check-mark-green-circle-lg"}/>
            <span className="overlay-content__label__text"><strong>{translate("Added to cart")}</strong></span>
            <button className="overlay-content__label__close svg-close-black75-lg"
                    onClick={() => setShowBasketOverlay(false)}/>
        </div>
    );
}
